var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.734,
    height: 6.513,
    viewBox: "0 0 8.734 6.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.966,10.962.128,8.124a.437.437,0,0,1,0-.618l.618-.618a.437.437,0,0,1,.618,0L3.275,8.8l4.1-4.1a.437.437,0,0,1,.618,0l.618.618a.437.437,0,0,1,0,.618L3.584,10.962A.437.437,0,0,1,2.966,10.962Z",
    transform: "translate(0 -4.577)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.52046c48bffabefbbe7ba5602239005a.svg";
export { ForwardRef as ReactComponent };